<template>
  <div id="app">

      <b-navbar ref="navbar" type="is-white" transparent v-bind:close-on-click="true">
      <!-- <template slot="brand"> -->
         <!-- <pre>{{user}}</pre> -->
         <template slot="brand">
            <b-navbar-item tag="router-link" :to="{ path: '/' }">
                <img
                    src="https://bikesleepbike.com/bsb_header_logo_light.png"
                    alt="Share and discover bicycle travel blogs"
                >
            </b-navbar-item>
        </template>
        <template slot="end" >
            <router-link to="/" exact class="navbar-item" >
              <span @click="closeMobileMenu">Home</span>
            </router-link>
            
            <!-- <router-link to="/list/routes" class="navbar-item" >
                <span @click="closeMobileMenu">Routes</span>
              </router-link>
              <router-link to="/list/countries" class="navbar-item" >
                <span @click="closeMobileMenu">Countries</span>
              </router-link> -->
            <b-navbar-dropdown id="browse-dropdown" ref="browse-dropdown" class="is-primary" close-on-click toggle hoverable label="Browse">
              <router-link to="/styles" class="navbar-item" >
                <span @click="closeMobileMenu">Styles</span>
              </router-link>
              <router-link to="/routes" class="navbar-item" >
                <span @click="closeMobileMenu">Routes</span>
              </router-link>
              <router-link to="/countries" class="navbar-item" >
                <span @click="closeMobileMenu">Countries</span>
              </router-link>
              <!-- <router-link to="/continents" class="navbar-item" >
                <span @click="closeMobileMenu">Continents</span>
              </router-link> -->
              <router-link to="/ridertags" class="navbar-item" >
                <span @click="closeMobileMenu">Rider Tags</span>
              </router-link>
              <router-link to="/sites" class="navbar-item" >
                <span @click="closeMobileMenu">Blogs</span>
              </router-link>
            </b-navbar-dropdown>
            <router-link to="/books" class="navbar-item" >
              <span @click="closeMobileMenu">Books</span>
            </router-link>
            <router-link to="/share" class="navbar-item" >
              <span @click="closeMobileMenu">Add Posts</span>
            </router-link>
            <router-link to="/about" class="navbar-item" >
              <span @click="closeMobileMenu">About</span>
            </router-link>
          
        </template>
        

    
  </b-navbar>
  <div class="is-size-7-mobile" v-if="bannerOpen && this.$route.path != '/' && this.$route.path != '/about'" style="background-color:#2763a1; color:white; padding: 10px; line-height:1.2em ">
    What is this? BikeSleepBike is a directory of bikepacking and touring blogs. 
    <router-link to="/about" style="color: rgb(243, 125, 94);">
              <span>Learn more here</span>
            </router-link>.
            <span @click="bannerOpen = false" style="cursor:pointer"><b-icon style="margin-left:15px"
                pack="fas"
                icon="times-circle"
                size="is-small">
            </b-icon></span>
            </div>
  <!-- <div class="spacer" style="height:50px"></div> -->
    <!-- <div class="banner-overlay"></div> -->
    <!-- <div class="banner-text"> -->
      <!-- <h2 class="has-text-primary banner-text" style="font-weight: normal; padding-top:10px; max-width: 810px; margin-left: auto; margin-right: auto">BikeSleepBike is a <strong class="has-text-primary">growing directory</strong> of independent <strong class="has-text-primary">bike travel blogs</strong> -->
                            <!-- organized by <strong class="has-text-primary">country, route, style</strong>, and more.</h2> -->
      <!-- </div> -->
      <!-- <img src="https://bikesleepbike.com/bsb_banner.jpg" class="find-banner-img"> -->
  
         
  <!-- <pre>{{this.$route.path}}</pre> -->

    <!-- <img src="./assets/logo.png"> -->
    <router-view :key="this.$route.path" />
    
    <!-- <router-view  /> -->
    <SocialSharePrompt :headerText="'BikeSleepBike'" :location="'side'"/>
  <footer class="footer">
    <div class="columns footer-columns">
      <div class="column">
        <div class="spacer" style="height:50px"></div>
        <a class="convertkit-button button is-light is-medium"  href="https://bikesleepbike.ck.page/products/support-bike-sleep-bike" data-commerce>Donate to support BSB</a>

        <SocialSharePrompt :headerText="'BikeSleepBike'" :location="'bottom'" :label="'Share with friends:'" :labelColor="'white'"/>
        <div class="spacer" style="height:50px"></div>
      </div>
      <div class="column emailform-column">
        <EmailForm />
      </div>
      <div class="column">
        <div class="content has-text-centered">
        <!-- <p> -->
          <div class="footer-nav-links">
            <div class="spacer" style="height:50px"></div>
            <div class="columns is-mobile" style="padding:20px 20px 20px 20px; max-width:500px; margin-left:auto; margin-right:auto">
              <div class="column" style="padding:0">
                <router-link to="/">Home</router-link>
                <router-link to="/styles">Styles</router-link>
                <router-link to="/countries">Countries</router-link>
                <router-link to="/routes">Routes</router-link>
                <!-- <router-link to="/continents">Continents</router-link> -->
                <router-link to="/ridertags">Rider Tags</router-link>
                
              </div>
              <div class="column" style="padding:0">
                <router-link to="/books">Books</router-link>
                <router-link to="/sites">Blogs</router-link>
                <router-link to="/share">Add Posts</router-link>
                <router-link to="/about">About</router-link>
                <router-link to="/contact">Contact</router-link>
              </div>
              
            </div>
            
            
            
           
          </div>
          
          
      </div>
    </div>
    </div>
    <span>Copyright 2023 BikeSleepBike</span>
</footer>

    <FormPopup />
    
    <!-- <div class="spacer" style="height:50px"></div>
    <SocialSharePrompt :headerText="'BikeSleepBike'" :location="'bottom'"/>
    <div class="spacer" style="height:50px"></div> -->

    <!-- <EmailForm /> -->
   
    <!-- <footer class="footer">
      <div class="content has-text-centered">
     
          <div class="footer-nav-links">
            <a href="/find">Find Posts</a>
            <a href="/share">Add Posts</a>
            <a href="/countries">Countries</a>
            <a href="/routes">Routes</a>
            <a href="/continents">Continents</a>
            <a href="/ridertags">Rider Tags</a>
            <a href="/about">About</a>
            <a href="/contact">Contact Us</a>
           
          </div>
          
          <span>Copyright 2021 BikeSleepBike</span>
          
      </div>
    </footer>  -->
  </div>
</template>

<script>
import SocialSharePrompt from '@/components/SocialSharePrompt';
import EmailForm from '@/components/EmailForm';
import FormPopup from '@/components/FormPopup';
export default {
  name: 'App',
  components: {SocialSharePrompt, EmailForm, FormPopup},
   watch: {
    $route(to, from) {
      // console.log("route changed ");
      // console.log(to.path);
      // this.$analytics.setCurrentScreen(to.path); // sets `screen_name` parameter
      // this.$analytics.logEvent('screen_view');
      this.$analytics.logEvent('screen_view', { screen_name: to.path,  firebase_screeen: to.path, firebase_screen_class: 'class' });
 
    }
  },
  created() {
    // console.log("Created APP");
    var that = this;
    // this.$firebase.auth().onAuthStateChanged(user => {
    //   // console.log("auth state changed to isAnon " + user.isAnonymous);
    //   console.log("**************auth state changed App.vue", user);
    //     // if (user) {
    //     //     that.user = user;
           
    //     // }
    // });


    // new
    this.$firebase.auth().onAuthStateChanged(function(user) {
      if (that.$debug) {console.log("+++Auth state changed in App.vue");}
      if (!user) {
          that.$firebase.auth().signInAnonymously().then(function() {
            if (that.$debug) {
              console.log("+++Signing in anonymously"); 
              console.log("isAnonymous, uid: ", that.$firebase.auth().currentUser.isAnonymous, that.$firebase.auth().currentUser.uid);
              // console.log("isAnonymous, uid: ", user.isAnonymous, user.uid);
            }
            that.user = that.$firebase.auth().currentUser;
          }).catch(function(error) {
            if (that.$debug) {console.log("+++ Error signing in anonymously", error); }
          });
      } else {
        if (that.$debug) {
          console.log("+++ already a user:", that.$firebase.auth().currentUser); 
          console.log("isAnonymous, uid: ", that.$firebase.auth().currentUser.isAnonymous, that.$firebase.auth().currentUser.uid);
          console.log("isAnonymous, uid: ", user.isAnonymous, user.uid);
        }
        
        that.user = that.$firebase.auth().currentUser;
      }
    });




  },
  data () {
    return {
      //  routes: [],
      //  riderTags: [],
       user: null,
       allRoutes: {},
       bannerOpen: true
      //  counts: {_posts: 3}
    }
    
  },
  methods: {
    // closeBanner() {

    // },
    closeMobileMenu()  {
      if (document.getElementsByClassName("navbar-burger is-active").length > 0) {
        document.getElementsByClassName("navbar-burger is-active")[0].click();
      }
    },
    closeDropdownMenu() {
      // console.log("closing");
      // this.$refs["browse-dropdown"].removeClass("is-active");
      console.log(this.$refs["browse-dropdown"].$el.classList);
    },
    getAllRoutes() {
      return this.allRoutes;
    }
  },
  beforeMount() {
    console.log(this.$route.query)
  },
  mounted() {
   
    // console.log("Mounted: Query string params found: ", this.$route.query);
    // var totals = {};
    // this.$db.collection("counts").doc("totals").get()
    //   .then(function(doc) {
          
    //       if (doc.exists){
    //           // console.log(doc.data());
    //           // console.log("Total");
    //           totals = doc.data();
    //       }
      
    //   }).catch(function(error) {
    //       console.error("Error fetching totals: ", error);
    //   });
    //   Object.defineProperty(Vue.prototype, '$totals', { value: totals });
      }
}
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /* margin-top: 60px; */
    background-color: #fafafa;
    overflow-x: hidden;
  }
  html {
    background-color: #fafafa !important;
  }
  .top-margin {
      margin-top:40px;
  }
  .field {
      margin-top:5px;
  }
  .card {
    /* box-shadow: none; */
    /* -webkit-box-shadow: none; */
  }
  .hint {
        display:block;
        font-size:0.9em;
        line-height: 1.2em;
        font-style: normal;
        color: #939393;
        margin: 5px 0 10px 0;
    }
    .header-panel {
      background-color:rgba(185, 238, 255, 0.37); 
      padding: 20px 100px;
    }
  a.navbar-item,
  .navbar-item.has-dropdown a {
    font-size:1.2em;
    padding: 8px 20px;
    /* color: #2763a1 !important; */
  }
  .navbar-item.has-dropdown a {
    padding-right: 50px;
  }
  a.navbar-item:hover,
  a.navbar-item.is-active  {
    text-decoration: underline;
    text-underline-position: under;
  }
  .navbar-item img {
    max-height:2.5rem !important;
  }
  .navbar-end {
    /* display:none !important; */
  }
  .navbar-start {
    margin-left:auto !important;
    margin-right:auto  !important;
  }

  /* @media screen and (min-width: 1024px) {
    .navbar.is-spaced .navbar-dropdown {
      opacity: 0.5;
    }

  } */
  @media screen and (max-width: 768px) {
    .what-is-banner {
      display:none;
    }
    .navbar-brand .navbar-item {
      display:none;
    }
    .navbar.is-white .navbar-burger {
      /* color: #2763a1; */
      margin-left: auto;
      margin-right: auto;
    }
    .navbar-menu.is-active {
      text-align: left;
    }
    .emailform-column {
      border-top:2px solid white;
      border-bottom:2px solid white;
    }
    .container {
      padding:20px;
    }
    .header-panel {
      padding: 10px 10px;
    }
  }

  .emailform-column {
    border-left:2px solid white;
    border-right:2px solid white;
  }

  .footer-columns {
    border-bottom:2px solid white;
  }

  .taginput.wrap {
    display:block !important;
  }
  .taginput.wrap .control {
      display:inline-block !important;
      margin-right:3px !important; 
      margin-bottom: 5px !important;
  }
  .taginput.wrap .control .button {
      border-radius: 0px !important;
  }
  /* .find-trips, .add-trips, .how-it-works, .page-results-list {
    max-width:1200px !important;
  } */
  .hidden {
    display:none;
  }
  .footer {
    padding: 20px  0 !important;
  }
  .footer a, .footer p, .footer span {
    color: white;
  }
  /* .footer a {
    text-decoration: underline;
    text-underline-position: under;
  } */
  a.has-hover:hover {
    text-decoration: underline;
  }
  a:hover {
    color: #f37d5e;
  }
  .footer-nav-links {
    margin-bottom: 15px;
  }
  .footer-nav-links a {
    text-decoration: none;
    margin-right: 15px;
    font-size: 1.1em;
    line-height: 2.3em;
    display:block;
  }
  .footer-nav-links a:hover {
    text-decoration: underline;
    text-underline-position: under;
    color: white;
  } 

  .banner-text {
    /* width: 100%;
    height: 100%;
    background: black;
    opacity: 0.5; */
  }
  .banner-text h2 {
    /* color: white; */
  }
  .banner-overlay {
    /* width:100vw;
      height:21vw;
      background-color: black;
      opacity: 0.5; */

  }
  .divider {
    height:3px;
    background-color:lightgray;
  }
  .card {
    box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0 0 1px rgb(10 10 10 / 2%);

  }
  .small-label {
       font-size:12px;
       color:#999898;
       display:block;
       text-transform:uppercase;
   }
   .list-page {
     max-width:1000px;
   }
 
</style>



// WEBPACK FOOTER //
// src/App.vue